module.exports = __webpack_public_path__ + "static/publicArt-25_2-c8778a55aa8d041f77ddb4f9a7378a96.jpg";